import { ArrowLeft } from './ArrowLeft';
import { ArrowRight } from './ArrowRight';
import { Bars } from './Bars';
import { BeGenuine } from './BeGenuine';
import { BoostIncome } from './BoostIncome';
import { CaretDown } from './CaretDown';
import { CaretRight } from './CaretRight';
import { Checkmark } from './Checkmark';
import { ChevronDown } from './ChevronDown';
import { ChevronUp } from './ChevronUp';
import { DistillTheMessage } from './DistillTheMessage';
import { Dynamic } from './Dynamic';
import { Facebook } from './Facebook';
import { HealthCare } from './Healthcare';
import { Holistic } from './Holistic';
import { Housing } from './Housing';
import { Instagram } from './Instagram';
import { InvestInGrowth } from './InvestInGrowth';
import { KeepMoreMoney } from './KeepMoreMoney';
import { LegacyGoals } from './LegacyGoals';
import { Lifestyle } from './Lifestyle';
import { LinkedIn } from './LinkedIn';
import { LowCost } from './LowCost';
import { Personalized } from './Personalized';
import { SocialSecurity } from './SocialSecurity';
import { StayOnTrack } from './StayOnTrack';
import { TakeAction } from './TakeAction';
import { TaxEfficient } from './TaxEfficient';
import { Taxes } from './Taxes';
import { Trusted } from './Trusted';
import { Twitter } from './Twitter';
import { User } from './User';
import { Xmark } from './Xmark';
import { colors } from 'component-library/styles/colors';
import { SpacingProps, spacingStyles } from 'component-library/styles/spacing';
import React, { FC } from 'react';
import styled from 'styled-components';

export enum IconName {
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  Bars = 'Bars',
  BeGenuine = 'BeGenuine',
  BoostIncome = 'BoostIncome',
  CaretDown = 'CaretDown',
  CaretRight = 'CaretRight',
  Checkmark = 'Checkmark',
  ChevronDown = 'ChevronDown',
  ChevronUp = 'ChevronUp',
  DistillTheMessage = 'DistillTheMessage',
  Dynamic = 'Dynamic',
  Facebook = 'Facebook',
  HealthCare = 'HealthCare',
  Holistic = 'Holistic',
  Housing = 'Housing',
  Instagram = 'Instagram',
  InvestInGrowth = 'InvestInGrowth',
  KeepMoreMoney = 'KeepMoreMoney',
  LegacyGoals = 'LegacyGoals',
  Lifestyle = 'Lifestyle',
  LinkedIn = 'LinkedIn',
  LowCost = 'LowCost',
  Personalized = 'Personalized',
  SocialSecurity = 'SocialSecurity',
  StayOnTrack = 'StayOnTrack',
  TakeAction = 'TakeAction',
  TaxEfficient = 'TaxEfficient',
  Taxes = 'Taxes',
  Trusted = 'Trusted',
  Twitter = 'Twitter',
  User = 'User',
  Xmark = 'Xmark',
}

export const icons = {
  [IconName.ArrowLeft]: ArrowLeft,
  [IconName.ArrowRight]: ArrowRight,
  [IconName.Bars]: Bars,
  [IconName.BeGenuine]: BeGenuine,
  [IconName.BoostIncome]: BoostIncome,
  [IconName.CaretDown]: CaretDown,
  [IconName.CaretRight]: CaretRight,
  [IconName.Checkmark]: Checkmark,
  [IconName.ChevronDown]: ChevronDown,
  [IconName.ChevronUp]: ChevronUp,
  [IconName.DistillTheMessage]: DistillTheMessage,
  [IconName.Dynamic]: Dynamic,
  [IconName.Facebook]: Facebook,
  [IconName.HealthCare]: HealthCare,
  [IconName.Holistic]: Holistic,
  [IconName.Housing]: Housing,
  [IconName.Instagram]: Instagram,
  [IconName.InvestInGrowth]: InvestInGrowth,
  [IconName.KeepMoreMoney]: KeepMoreMoney,
  [IconName.LegacyGoals]: LegacyGoals,
  [IconName.Lifestyle]: Lifestyle,
  [IconName.LinkedIn]: LinkedIn,
  [IconName.LowCost]: LowCost,
  [IconName.Personalized]: Personalized,
  [IconName.SocialSecurity]: SocialSecurity,
  [IconName.StayOnTrack]: StayOnTrack,
  [IconName.TakeAction]: TakeAction,
  [IconName.TaxEfficient]: TaxEfficient,
  [IconName.Taxes]: Taxes,
  [IconName.Trusted]: Trusted,
  [IconName.Twitter]: Twitter,
  [IconName.User]: User,
  [IconName.Xmark]: Xmark,
};

export interface IconProps extends SpacingProps {
  name: IconName;
  color?: string;
  backgroundColor?: string;
  onClick?: () => void;
}

const styledIcon = (
  component: React.FC<React.SVGProps<SVGSVGElement>>,
) => styled(component)`
  ${spacingStyles}
`;

export const Icon: FC<IconProps> = ({
  name,
  color,
  backgroundColor,
  ...rest
}) => {
  const SelectedIcon = styledIcon(icons[name]);

  const args = {
    fill: color || colors.navyBlue,
    backgroundColor,
    ...rest,
  };

  return <SelectedIcon {...args} />;
};
